import { render } from "./compact_icon.vue?vue&type=template&id=1f99cbf9"
import script from "./compact_icon.vue?vue&type=script&lang=js"
export * from "./compact_icon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benny\\Documents\\Programmieren\\Vue\\cellCalculator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__